import { LoadingContainer, ModelList } from 'peach/components'
import { useParams, useRouteMatch, useHistory } from 'peach/router'
import { useClickAction } from 'peach/decorators/withActionTrigger'

import { Page } from 'core/components'
import { useInternalSupercaseList } from 'core/types'

const Supercases = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()

  const { data: supercases, isLoading } = useInternalSupercaseList({
    companyId,
  })

  useClickAction({
    label: 'Create Supercase',
    onClick: () => history.push(`${url}/create`),
  })

  return (
    <LoadingContainer loading={isLoading}>
      <Page variant='full'>
        <ModelList
          json={supercases}
          title='Supercases'
          withDetails
          withRelated
          withTimestamps
        />
      </Page>
    </LoadingContainer>
  )
}

export default Supercases
